import { gql } from "@apollo/client";

import { SALES_PERSON_SPLIT_FIELDS } from "../query/SalesPeopleSplit";

const SET_CONSIGNMENT_SALES_PEOPLE = gql`
  mutation SetConsignmentSalesPeople($input: SetConsignmentSalesPeopleInput!) {
    setConsignmentSalesPeople(input: $input) {
      success
      error
      consignmentSalesPeople {
        ${SALES_PERSON_SPLIT_FIELDS}
      }
    }
  }
`;

const SET_OFFER_SALES_PEOPLE = gql`
  mutation SetOfferSalesPeople($input: SetOfferSalesPeopleInput!) {
    setOfferSalesPeople(input: $input) {
      success
      error
      offerSalesPeople {
        ${SALES_PERSON_SPLIT_FIELDS}
      }
    }
  }
`;

export { SET_CONSIGNMENT_SALES_PEOPLE, SET_OFFER_SALES_PEOPLE };
